import React, { useState, useContext, useEffect } from "react";
import { HStack, IconButton, Stack, Text, VStack, } from "@chakra-ui/react";
import { FiEdit2, FiTrash2, FiPlus, FiPenTool, FiLayers } from "react-icons/fi";
import { useNavigate  } from "react-router-dom";
import { AppContext } from "../../App";
import { IApiDeficitResponse } from "../../models/api/deficit/IApiDeficitResponse";
import { ApiContext } from "../../contexts/ApiProvider";
import toast from "react-hot-toast";
import { AddDeficitDrawer } from "../../components/drawers/deficit/AddDeficitDrawer";
import { EditDeficitDrawer } from "../../components/drawers/deficit/EditDeficitDrawer";
import { IApiDeficitEditRequest } from "../../models/api/deficit/IApiDeficitEditRequest";
import Helpers from "../../Helpers";
import { AlgoliaTable } from "../../components/AlgoliaTable/AlgoliaTable";

interface IDeficitsProps {

}

export const Deficits: React.FunctionComponent<IDeficitsProps> = (props: IDeficitsProps) => {

    const navigate = useNavigate();
    const { me, setAppShellConfig } = useContext(AppContext);
    const { postDeficit, patchDeficit, deleteDeficit } = useContext(ApiContext);

    const addState = useState(false);
    const [add, setAdd] = addState;

    useEffect(() => {
        setAppShellConfig({
            breadcrumbs: [{
                text: `Vorlagen`,
                icon: FiLayers,
            },
            {
                text: `Mängel`,
                icon: FiPenTool
            }],
            rightButton: {
                text: "Erstellen",
                icon: FiPlus,
                ariaLabel: "erstellen",
                variant: "primary",
                onClick: () => {
                    setAdd(true);
                }
            }
        });
    }, [setAppShellConfig, me, navigate, setAdd]);

    return (
        <Stack spacing="4" height="full" direction="column">
            <AlgoliaTable<IApiDeficitResponse> 
                indexName="dev_deficits"
                getColumns={(columnHelper, setEdit, deleteAction) => [
                    columnHelper.accessor('value', {
                        header: () => 'Bezeichnung',
                        cell: info => info.getValue()
                    }),
                    columnHelper.display({
                        id: 'actions',
                        cell: info => {
                            const deficit = info.row.original;
                            return (
                                <HStack spacing="0" justifyContent="end">
                                    <IconButton
                                        icon={<FiEdit2 fontSize="1.125rem" />}
                                        variant="ghost"
                                        aria-label="Bearbeiten"
                                        onClick={(e) => { 
                                            e.stopPropagation(); 
                                            setEdit(deficit);
                                        }}
                                    />
                                    <IconButton
                                        icon={<FiTrash2 fontSize="1.125rem" />}
                                        variant="ghost"
                                        aria-label="Löschen"
                                        onClick={(e) => { 
                                            e.stopPropagation();
                                            deleteAction(deficit);
                                        }}
                                    />                           
                                </HStack>
                            );
                        },
                    }),
                ]}
                getCard={(deficit, setEdit, deleteAction) => ({
                    key: deficit.id,
                    value: deficit.id,
                    content: (
                        <HStack spacing="4" justifyContent="space-between">
                            <VStack spacing="2" align="left">
                                <Text fontWeight="medium" fontSize={{ base: "sm", md: "md" }}>
                                    {deficit.value}
                                </Text>
                            </VStack>
                            <HStack spacing="4" justifyContent="end">
                                <IconButton
                                    icon={<FiEdit2 fontSize="1.25rem" />}
                                    variant="ghost"
                                    aria-label="Bearbeiten"
                                    onClick={(e) => { 
                                        e.stopPropagation(); 
                                        setEdit(deficit);
                                    }}
                                />
                                <IconButton
                                    icon={<FiTrash2 fontSize="1.25rem" />}
                                    variant="ghost"
                                    aria-label="Löschen"
                                    onClick={(e) => { 
                                        e.stopPropagation(); 
                                        deleteAction(deficit);
                                    }}
                                />
                            </HStack>
                        </HStack>
                    )
                })}
                deleteAction={(item, deleteItem) => ({
                    title: `Eintrag löschen`,
                    body: `Sind Sie sicher, dass dieser Eintrag gelöscht werden soll?`,
                    onConfirm: () => {
                        var promise = deleteDeficit(item.id);
                        toast.promise(promise, {
                            loading: `Eintrag wird gelöscht...`,
                            success: (result) => {
                                deleteItem(result);
                                return `Der Eintrag wurde erfolgreich gelöscht!`;
                            },
                            error: (code) => Helpers.buildToastErrorMessage(code, `Fehler beim Löschen des Eintrags!`)
                        });
                        return promise;
                    }
                })}
                addState={addState}
                getAddDrawer={([state, setState], addItem) => (
                    <AddDeficitDrawer 
                        isOpen={state} 
                        onDiscard={() => setState(false)}
                        onSubmit={(data) => {
                            var promise = postDeficit(data);
                            toast.promise(promise, {
                                loading: `Eintrag wird erstellt...`,
                                success: (result) => {
                                    setState(false);
                                    addItem(result);
                                    return `Der Eintrag wurde erfolgreich erstellt!`;
                                },
                                error: (code) => Helpers.buildToastErrorMessage(code, `Fehler beim Erstellen des Eintrags!`)
                            });
                            return promise;
                        }}
                    />
                )}
                getEditDrawer={([state, setState], replaceItem) => (
                    <EditDeficitDrawer 
                        defaultValue={state as IApiDeficitEditRequest} 
                        onDiscard={() => setState(undefined)} 
                        onSubmit={(data) => {
                            var promise = patchDeficit(state!.id, data);
                            toast.promise(promise, {
                                loading: `Eintrag wird aktualisiert...`,
                                success: (result) => {
                                    setState(undefined);
                                    replaceItem(result)
                                    return `Der Eintrag wurde erfolgreich aktualisiert!`;
                                },
                                error: (code) => Helpers.buildToastErrorMessage(code, `Fehler beim Aktualisieren des Eintrags!`)
                            });
                            return promise;
                        }}
                    />
                )}
            />
        </Stack>
    );

}